import React from 'react'
import Relay from 'react-relay'
import moment from 'moment'

import Circle from './Circle'
import Button from './Button';


import { appStyles, colors, fonts } from '../theme'

const dtFmt = (date) => moment(date).format('YYYY MM DD HH:mm')

const Users = ({ users }) =>
  <ul>
    {users.map((user, index) => (
      <li
        key={index}
        style={styles.listItem}
      >
        <Circle image={user.avatar} style={styles.icon} />
        {user.pseudo}
      </li>
    ))}
  </ul>

const Field = ({ title, content }) =>
  <div style={{display: 'flex',flexDirection:'row', paddingBottom:5, paddingTop:10, paddingLeft:20}}>
    <label style={{paddingLeft:5, flex: '0 100px'}}>{title} :</label>
    <div style={{paddingLeft:20, flex: 1}}>
      {content}
    </div>
  </div>

const ChatPanel = ({ chat: { sportunity }, chat, relay }) => (
  <table className="table table-hover table-condensed table-bordered">
    <tbody>
      <tr>
        <td>
          <div>
            <Field
              title="Created at"
              content={chat.messageCount > 0 ? dtFmt(chat.messages.edges[0].node.created) : ''}
            />
            <Field
              title="Users"
              content={<Users users={chat.users} />}
              />
            <div>
              {sportunity && (
                <Field
                  title="Group"
                  content={<span>{sportunity.title}, {sportunity.beginning_date}</span>}
                  />
              )}
            </div>
            <div>Total messages: {chat.messageCount}</div>
          </div>
        </td>
      </tr>
      <tr>
        <td>
        <table className="table table-hover table-condensed table-bordered">
          <tbody>
            {((chat.messages && chat.messages.edges) || []).map(
              ({ node: message }, index) => (
                <tr key={index}>
                  <td style={styles.listItem}>
                    <Circle
                      image={message.author.avatar}
                      iconStyle={styles.smallIcon}
                    />
                    {message.author.pseudo} ({moment(message.created).format('YYYY MM DD HH:mm')}): {message.text}
                  </td>
                </tr>
              )
            )}
            {chat.messages.pageInfo.hasNextPage && (
              <tr>
                <td style={{
                  justifyContent: 'space-around',
                  display: 'flex',
                  flexDirection: 'column',
                }}>
                  <Button
                    onClick={() => relay.setVariables({
                      messagesSize: relay.variables.messagesSize*2
                    })}
                    style={styles.close}
                    text={(
                      <span>
                        <i style={styles.closeIcon} className="glyphicon glyphicon-plus-sign glyphicon-2x" />
                        Load more
                      </span>
                    )}
                  />
                </td>
              </tr>
            )}
          </tbody>
        </table>

        </td>
      </tr>
    </tbody>
  </table>
)

const styles = {
  list: {
		width: '100%',
	},
	listItem: {
		paddingBottom: 10,
		color: '#515151',
		fontSize: 16,
		fontWeight: 500,
		fontFamily: 'Lato',
    borderTopWidth: 0,
		borderBottomWidth: 1,
		borderColor: colors.gray,
		borderStyle: 'solid',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'flex-start',
		alignItems: 'center',
	},
	icon: {
    display: 'inline-block',
    width: 38,
    height: 38,
    margin: '5px 13px 0 32px',
  },
	smallIcon: {
    display: 'inline-block',
    width: 24,
    height: 24,
    margin: 10,
  },
}

export default Relay.createContainer(ChatPanel, {
  initialVariables: {
    messagesSize: 20,
  },
  fragments: {
    chat: () => Relay.QL`
      fragment on Chat {
        id
        users {
          id
          pseudo
          avatar
        }
        sportunity {
          id
          title
        }
        isActive
        messageCount
        messages(first:$messagesSize) {
          edges {
            node {
              id
              author {
                id
                pseudo
                avatar
              }
              text
              created
            }
          }

          pageInfo {
            hasNextPage
          }
        }
      }
    `,
  }
})



// WEBPACK FOOTER //
// ./src/components/ChatPanel.js